import { React, PT } from '@gasbuddy/react';
import { Form, Header, Button, Modal, Message, Container } from 'semantic-ui-react';
import { fetch } from '../../../client/lib/fetch';

export class SpendLimits extends React.Component {
  state = {
    loading: false,
    newSpendLimit: undefined,
    spendLimitUpdateError: undefined,
    shouldShowUpdateSpendLimitModal: false,
  }

  updateSpendLimit = async (e) => {
    e.preventDefault();
    const { onUpdate } = this.props;
    const { newSpendLimit } = this.state;
    this.setState({ loading: true }, async () => {
      const { instrument } = this.props;
      try {
        await fetch('/payments/instrument/spend-limits', {
          instrument_id: instrument.instrument_id,
          account_id: instrument.account_id,
          spend_limit_name: newSpendLimit,
        });
        this.setState({ loading: false, shouldShowUpdateSpendLimitModal: false });
        onUpdate();
      } catch (error) {
        this.setState({ spendLimitUpdateError: error, loading: false });
      }
    });
  }

  render() {
    const { spendLimits, currentSpendLimit } = this.props;
    const { newSpendLimit, spendLimitUpdateError, loading, shouldShowUpdateSpendLimitModal } = this.state;
    const spendLimit = !!spendLimits.length && spendLimits.find(sl => sl.name === currentSpendLimit);
    const newSpendLimitDetail = !!spendLimits.length && spendLimits.find(sl => sl.name === newSpendLimit);

    return !!spendLimit && (
      <React.Fragment>
        <Button onClick={() => { this.setState({ shouldShowUpdateSpendLimitModal: true }); }}>
          Change Spend Limits
        </Button>
        <Modal
          size="small"
          closeIcon
          open={shouldShowUpdateSpendLimitModal}
          onClose={() => this.setState({ shouldShowUpdateSpendLimitModal: false })}
        >
          <Modal.Content>
            <Container>
              <Header icon="money bill alternate outline" content="Change Spend Limits" />
              {loading ? (
                <React.Fragment>
                  <br />
                  <br />
                  Updating spending limit...
                  <br />
                  <br />
                  <br />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {!!spendLimitUpdateError?.length && (
                    <Message negative>
                      <p>Error updating spend limit</p>
                    </Message>
                  )}
                  {!!spendLimitUpdateError?.length && (
                    <Message negative>
                      <p>Error updating spend limit</p>
                    </Message>
                  )}
                  <p>Current spend limit for this account is set to</p>
                  <strong>
                    {spendLimit.display_name}
                    (
                    {spendLimit.daily_limit ? `${spendLimit.daily_limit} Daily` : 'No Daily Limit'}
                    &nbsp;/&nbsp;
                    {spendLimit.weekly_limit ? `${spendLimit.weekly_limit} Weekly` : 'No Weekly Limit'}
                    )
                  </strong>
                  <br />
                  <br />
                  <br />
                  <Form horizontal error={!!spendLimitUpdateError}>
                    <Form.Group inline>
                      <Form.Dropdown
                        upward
                        label="Update payment profile to"
                        defaultValue={currentSpendLimit}
                        options={spendLimits.map(sl => ({ text: sl.display_name, value: sl.name }))}
                        onChange={(e, { value }) => this.setState({ newSpendLimit: value })}
                      />
                      <Form.Button onClick={this.updateSpendLimit}>Update</Form.Button>
                    </Form.Group>
                    {newSpendLimitDetail ? (
                      <p>
                        Spend limits for selected payment profile: (
                        {newSpendLimitDetail.daily_limit ? `${newSpendLimitDetail.daily_limit} Daily` : 'No Daily Limit'}
                        &nbsp;/&nbsp;
                        {newSpendLimitDetail.weekly_limit ? `${newSpendLimitDetail.weekly_limit} Weekly` : 'No Weekly Limit'}
                        )
                      </p>
                    ) : (
                      <p>
                        Spend limits for selected payment profile: (
                        {spendLimit.daily_limit ? `${spendLimit.daily_limit} Daily` : 'No Daily Limit'}
                        &nbsp;/&nbsp;
                        {spendLimit.weekly_limit ? `${spendLimit.weekly_limit} Weekly` : 'No Weekly Limit'}
                        )
                      </p>
                    )}
                  </Form>
                </React.Fragment>
              )}
            </Container>
          </Modal.Content>
        </Modal>
      </React.Fragment>
    );
  }
}

SpendLimits.propTypes = {
  instrument: PT.shape({
    account_id: PT.number,
    instrument_id: PT.number,
  }).isRequired,
  spendLimits: PT.arrayOf(
    PT.shape({
      name: PT.string.isRequired,
      id: PT.string.isRequired,
      daily_limit: PT.string.isRequired,
      weekly_limit: PT.string.isRequired,
      display_name: PT.string.isRequired,
    }),
  ),
  currentSpendLimit: PT.string.isRequired,
  onUpdate: PT.func,
};

SpendLimits.defaultProps = {
  spendLimits: [],
  onUpdate: () => {},
};
